import {
    GiftCardProps,
    APIGiftCardProps,
    OrderStatus,
    APIOrderStatus,
    OrderConfirmation,
    APIOrderConfirmation,
    GiftCardCheckout,
    APIGiftCardCheckout,
} from "./gift-card-interface";

export const transformGiftCard = (apiGiftCard: APIGiftCardProps): GiftCardProps => ({
    id: apiGiftCard.id,
    name: apiGiftCard.attributes.name,
    code: apiGiftCard.attributes.code,
    sku: apiGiftCard.attributes.sku,
    supplier: apiGiftCard.attributes.supplier,
    locale: apiGiftCard.attributes.locale,
    details: apiGiftCard.attributes.details,
    expiry: apiGiftCard.attributes.expiry,
    terms: apiGiftCard.attributes.terms,
    inStoreOnly: apiGiftCard.attributes.in_store,
    imageUrl: apiGiftCard.attributes.imageUrl,
    denominations: apiGiftCard.attributes.denominations
        .map((d) => ({
            amount: Number(d.amount),
            currency: d.currency,
            stockLevel: d.stock_level,
        }))
        .filter((gc) => !!gc.amount),
    links: {
        self: `/gift-cards/${apiGiftCard.attributes.code}`,
    },
});

export const transformOrderConfirmation = (
    orderConfirmation: APIOrderConfirmation
): OrderConfirmation => {
    const { order_id, order_status, payment_id } = orderConfirmation;
    return {
        orderId: order_id,
        orderStatus: order_status,
        paymentId: payment_id,
    };
};

export const transformOrderStatus = (orderStatus: APIOrderStatus): OrderStatus => {
    const { order_status, error_code, payment_id, order_number } = orderStatus;
    return {
        orderStatus: order_status,
        errorCode: error_code,
        paymentId: payment_id,
        orderNumber: order_number,
    };
};

export const transformCheckout = (giftCardCheckout: GiftCardCheckout): APIGiftCardCheckout => {
    const { gift_card_id, amount, currency, isGift, consumer, recipient } = giftCardCheckout;
    return {
        gift_card_id,
        amount,
        currency,
        is_gift: isGift,
        consumer_firstname: consumer.firstname,
        consumer_lastname: consumer.lastname,
        consumer_email: consumer.email,
        recipient_name: recipient.name,
        recipient_email: recipient.email,
        recipient_message: recipient.message,
        client_host: location.host,
    };
};
